import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const stopIcons = {
  PICKUP: 'load-pickup',
  DROPOFF: 'load-dropoff',
};

const StopIconCell = ({ stopType }) => {
  return <Icon glyph={stopIcons[stopType]} size="1.6rem" color="grey500" />;
};

StopIconCell.propTypes = {
  stopType: PropTypes.string,
};

export default StopIconCell;
